module.exports = __webpack_public_path__ + "static/media/Player2.07bbbf22.png";